import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject } from '@ember/service';
import { dropTask } from 'ember-concurrency';
import '../lib/utility/ajax.js';
import { typeOf } from '@ember/utils';
import 'moment-timezone';
import { addRelationship } from '../lib/utility/relationships.js';
import 'ember-inflector';
import '../lib/utility/province.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<span ...attributes>\n  {{#if @showButton}}\n    <div class=\'more\' data-toggle=\'{{@zfIntId}}\'>\n      <FaIcon @icon={{@buttonIcon}} />\n\n      <span class=\'description\'>\n        {{this.relatedRelationshipLabel}}\n      </span>\n    </div>\n  {{/if}}\n\n  <BbModalModern\n    @isOpen={{@showModal}}\n    @title=\'{{this.relatedRelationshipLabel}}\'\n    @closeOnBackdrop={{true}}\n    @onClose={{@toggleModal}} data-test-toggle-modal\n  >\n    <:main>\n      <BelongsTo\n        @applicationController={{@applicationController}}\n        @relatedBelongsTo={{this.tmpItem}}\n        @relatedModelType={{this.relatedBelongsToModelType}}\n        @relatedFieldName=\'label\'\n        @showOnlyField={{true}}\n        @showSearchThumbnail={{true}}\n        @setContent={{this.setTmpItem}}\n      />\n    </:main>\n    <:footer>\n      {{#if this.tmpItem}}\n        <button\n          role=\'button\'\n          class=\'button primary expanded {{if this.saveRelatedTask.isRunning \"loading\"}}\'\n          disabled={{this.saveRelatedTask.isRunning}}\n          data-test-save-related\n          {{on \'click\' (perform this.saveRelatedTask)}}\n        >\n          {{t \'save relation\'}}\n        </button>\n      {{else}}\n        <button role=\'button\' class=\'button disabled expanded\' disabled=\'disabled\'>\n          {{t \'save relation\'}}\n        </button>\n      {{/if}}\n    </:footer>\n  </BbModalModern>\n</span>");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
let BbAssociateButtonComponent = (_class = class BbAssociateButtonComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "tmpItem", _descriptor4, this);
    _initializerDefineProperty(this, "filter", _descriptor5, this);
  }
  get statusSelected() {
    return this.args.status ?? null;
  }
  get relatedRelationshipLabel() {
    const organization = this.session.me?.organization;
    const retString = `${this.intl.t('associate')} `;
    if (this.args.isContact) {
      return retString + (organization?.contact_name || '');
    }
    if (this.args.isProduct) {
      return retString + (organization?.product_name || '');
    }
    if (this.args.isProject) {
      return retString + (organization?.project_name || '');
    }
    return retString;
  }
  get relatedBelongsToModelType() {
    if (this.args.isContact) {
      return 'contact';
    }
    if (this.args.isProduct) {
      return 'product';
    }
    if (this.args.isProject) {
      return 'project';
    }
    return null;
  }
  get stateToLoop() {
    if (this.args.isProduct) return this.session.productStates;
    if (this.args.isProject) return this.session.projectStates;
    return this.session.contactStates;
  }
  setTmpItem(val) {
    this.tmpItem = val;
  }
  toggleFilter() {
    this.filter = !this.filter;
  }
  *saveRelatedTask() {
    if (!this.args.items || !this.tmpItem) {
      return false;
    }
    if (typeOf(this.args.actionSave) === 'function') {
      this.args.actionSave(this.tmpItem);
    } else {
      this.args.items.forEach(item => {
        let sItem = item;
        if (!sItem.constructor?.modelName) {
          sItem = this.store.peekRecord(item.type, item.id);
        }
        addRelationship(this.tmpItem, sItem);
      });
      const queued = this._pendingRelationCount(this.tmpItem);
      yield this.args.applicationController.syncroRelation(this.tmpItem);
      if (this.isDestroying || this.isDestroyed) {
        return false;
      }

      // `syncroRelation` belongs to the never-rejecting save family: on failure
      // it reports through `saveError` and resolves with nothing — exactly what
      // it resolves with on success, so its return value cannot be checked.
      // What it DOES do only on success is empty the record's relation queue
      // (application.js:1869). A queue that is still as full as before the call
      // therefore means the server refused: closing the modal here would tell
      // the user the association was stored and throw away their pick.
      if (queued > 0 && this._pendingRelationCount(this.tmpItem) >= queued) {
        return false;
      }
      if (this.args.toggleModal) {
        this.args.toggleModal();
      }
    }
    return true;
  }
  _pendingRelationCount(item) {
    return (item?.addedRelated?.length ?? 0) + (item?.removedRelated?.length ?? 0);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "tmpItem", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "filter", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setTmpItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTmpItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleFilter", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveRelatedTask", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "saveRelatedTask"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbAssociateButtonComponent);

export { BbAssociateButtonComponent as default };
//# sourceMappingURL=bb-associate-button.js.map
